import React from 'react';

const PricingSection = ({ onOpenModal }) => {
  return (
    <section className="sec sec--tint" id="pricing">
      <div className="shell">
        <div className="sec-head rv">
          <h2 className="h2">How much does UAE Corporate Tax filing cost?</h2>
          <p className="answer">
            Standard Auditing charges AED 750 plus VAT to prepare and file a Corporate Tax return where you qualify to
            elect Small Business Relief, and AED 1,500 plus VAT where the tax has to be computed and paid. Both cover
            one return for one financial year and include Corporate Tax registration support.
          </p>
        </div>

        <div className="plans">
          {/* Plan 1 */}
          <div className="plan rv">
            <h3>Filing only</h3>
            <p className="who">
              For companies whose revenue has never exceeded AED 3 million and which qualify to elect Small Business
              Relief.
            </p>
            <p className="price">
              <span className="cur">AED</span>
              <span className="amt">750</span>
              <span className="vat">plus VAT</span>
            </p>
            <p className="price-note">One return, one financial year.</p>
            <ul>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#e1edf5" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#0a3d62" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Small Business Relief eligibility assessment, including the cumulative revenue test</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#e1edf5" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#0a3d62" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Corporate Tax registration support</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#e1edf5" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#0a3d62" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Corporate Tax return preparation</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#e1edf5" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#0a3d62" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Compliance check against your trade licence and financials</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#e1edf5" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#0a3d62" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Review and submission on the EmaraTax portal</span>
              </li>
            </ul>
            <button
              className="btn btn--ghost js-open-modal"
              onClick={onOpenModal}
              aria-label="Book a free review about the AED 750 filing only plan"
            >
              Book a free review
            </button>
          </div>

          {/* Plan 2 */}
          <div className="plan plan--feat rv">
            <span className="plan-tag">Most businesses</span>
            <h3>Filing and tax payable</h3>
            <p className="who">
              For companies that must compute and pay Corporate Tax, typically once revenue has passed AED 3 million.
            </p>
            <p className="price">
              <span className="cur">AED</span>
              <span className="amt">1,500</span>
              <span className="vat">plus VAT</span>
            </p>
            <p className="price-note">One return, one financial year.</p>
            <ul>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>
                  <b>Everything in Filing only</b>
                </span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Full tax computation and payment summary</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Review of financials and year-end adjustments</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Compliance review and supporting documentation</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>Advice on allowable deductions and adjustments</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="11" fill="#f6e5c0" />
                  <path d="M7.5 12.4l3 3 6-6.4" stroke="#a37922" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span>A named accountant on WhatsApp and email</span>
              </li>
            </ul>
            <button
              className="btn js-open-modal"
              onClick={onOpenModal}
              aria-label="Book a free review about the AED 1,500 filing and tax payable plan"
            >
              Book a free review
            </button>
          </div>
        </div>

        <p className="plans-foot rv">
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="10" stroke="#0a3d62" strokeWidth="1.7" />
            <path d="M12 11v6M12 7.5v.01" stroke="#0a3d62" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <span>
            Both fees cover a single Corporate Tax return for one financial year, and VAT is charged at 5% on the fee.{' '}
            <b>Small Business Relief applies only to tax periods ending on or before 31 December 2026.</b> For year ends after
            that, the AED 375,000 nil band and the 9% rate apply unless the rules are extended. Bookkeeping, statutory
            audit and VAT return work are quoted separately. If your books are not in a filing-ready state we will say so
            on the call, not three days before the deadline.
          </span>
        </p>
      </div>
    </section>
  );
};

export default PricingSection;
